/*! Added by AM — Custom Slideshow infinite scroll toggle */
(() => {
  if (window.__amInfiniteSlideshowLoading) return;
  window.__amInfiniteSlideshowLoading = true;

  const isInfinite = (el) => el.dataset.infinite !== 'false';

  const pageCount = (el) =>
    (el.sliderItemsToShow || el.sliderItems || []).length;

  /* Subpixel / scroll-snap safe edges (fails on some mobile + zoomed desktops otherwise) */
  const atFirst = (el) =>
    !el.slider || el.slider.scrollLeft <= 1 || el.currentPage <= 1;

  const atLast = (el) => {
    if (!el.slider) return false;
    const n = pageCount(el);
    if (n && el.currentPage >= n) return true;
    return (
      el.slider.scrollLeft + el.slider.clientWidth >= el.slider.scrollWidth - 2
    );
  };

  const syncDots = (el) => {
    const buttons = el.querySelectorAll('.slider-counter__link');
    if (!buttons.length || !el.sliderItemOffset) return;
    el.currentPage = Math.round(el.slider.scrollLeft / el.sliderItemOffset) + 1;
    buttons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    const active = buttons[el.currentPage - 1];
    if (!active) return;
    active.classList.add('slider-counter__link--active');
    active.setAttribute('aria-current', true);
  };

  const patch = () => {
    const Slideshow = customElements.get('slideshow-component');
    if (!Slideshow || Slideshow.prototype.__amInfinitePatched) return;

    const proto = Slideshow.prototype;
    const sliderProto = Object.getPrototypeOf(proto);
    const { onButtonClick, update } = proto;

    proto.autoRotateSlides = function () {
      if (!this.slider || !this.sliderItemOffset) return;

      if (!isInfinite(this)) {
        if (atLast(this)) {
          this.pause();
          return;
        }
        this.setSlidePosition(this.slider.scrollLeft + this.sliderItemOffset);
        this.applyAnimationToAnnouncementBar();
        return;
      }

      this.setSlidePosition(
        atLast(this) ? 0 : this.slider.scrollLeft + this.sliderItemOffset,
      );
      this.applyAnimationToAnnouncementBar();
    };

    proto.onButtonClick = function (event) {
      if (!isInfinite(this)) {
        const prev = event.currentTarget.name === 'previous';
        const next = event.currentTarget.name === 'next';
        if ((prev && atFirst(this)) || (next && atLast(this))) return;
        event.preventDefault();
        this.wasClicked = true;
        sliderProto.onButtonClick.call(this, event);
        return;
      }

      event.preventDefault();
      this.wasClicked = true;
      const dir = event.currentTarget.name;
      const n = pageCount(this);

      if (
        dir === 'previous' &&
        atFirst(this) &&
        this.sliderFirstItemNode &&
        n
      ) {
        this.slideScrollPosition =
          this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * n;
      } else if (dir === 'next' && atLast(this)) {
        this.slideScrollPosition = 0;
      } else {
        onButtonClick.call(this, event);
        return;
      }

      this.setSlidePosition(this.slideScrollPosition);
      this.applyAnimationToAnnouncementBar(dir);
    };

    proto.update = function () {
      this.enableSliderLooping = isInfinite(this);
      if (!this.slider) return;

      if (!this.nextButton || !this.prevButton) {
        syncDots(this);
        return;
      }

      update.call(this);
      if (this.enableSliderLooping) return;

      if (atFirst(this)) this.prevButton.setAttribute('disabled', 'disabled');
      else this.prevButton.removeAttribute('disabled');

      if (atLast(this)) this.nextButton.setAttribute('disabled', 'disabled');
      else this.nextButton.removeAttribute('disabled');
    };

    proto.__amInfinitePatched = true;

    document
      .querySelectorAll('slideshow-component.am-custom-slideshow')
      .forEach((el) => {
        el.enableSliderLooping = isInfinite(el);
        if (typeof el.update === 'function') el.update();
      });
  };

  if (customElements.get('slideshow-component')) patch();
  else customElements.whenDefined('slideshow-component').then(patch);
})();
